export default {
    allCategories: 'Sve Kategorije'
}
